module.exports = __webpack_public_path__ + "32b6b5144f067a00b430c8959d87b79f.svg";